export default __webpack_public_path__ + "static/media/telegram.ef1c3aaa.svg";